import { render, staticRenderFns } from "./TourTypeForm.vue?vue&type=template&id=53c8d1fd"
import script from "./TourTypeForm.vue?vue&type=script&lang=js"
export * from "./TourTypeForm.vue?vue&type=script&lang=js"
import style0 from "./TourTypeForm.vue?vue&type=style&index=0&id=53c8d1fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports